import React from 'react';
import { Link } from 'react-router-dom';
import './styles/footer.scss'; 

const Footer = () => {
    return (
      <footer className="footer">
        <div className="footer__copywrite">
          <p>Copyright (c) 2024  テキストテキストテキスト All Rights Reserved.</p>
        </div>
      </footer>
    );
  };

export default Footer;